
import { mapGetters } from "vuex"
import Animations from "@/components/base/Animations"

export default {
    name: "Stream",
    components: { Animations },
    props: {
        /**
         * flag indicating if the stream should autoplay
         */
        noAutoplay: {
            type: Boolean,
            default: false,
        },
        /**
         * flag indicating if the stream should display controls in an overlay
         */
        noControls: {
            type: Boolean,
            default: false,
        },
        /**
         * flag indicating if a thumbnail should be shown while the video is loading, or not started
         */
        noThumbnail: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            hls: null,
            likes: 0,
        }
    },
    watch: {
        videoUrl: function (value) {
            if (!value) return
            const Hls = require("hls.js")
            var video = this.$refs.videoContainer
            if (video.canPlayType("application/vnd.apple.mpegurl")) {
                video.src = value
            } else if (Hls.isSupported()) {
                var hls = new Hls()
                hls.loadSource(value)
                hls.attachMedia(video)
            }
        },
        volume(val) {
            this.$refs.videoContainer.volume = val
        },
        likeCount() {
            this.likes++
        },
    },
    mounted() {
        if (this.videoUrl && process.client) {
            this.$nextTick(() => {
                const Hls = require("hls.js")
                var video = this.$refs.videoContainer
                if (video.canPlayType("application/vnd.apple.mpegurl")) {
                    video.src = this.videoUrl
                } else if (Hls.isSupported()) {
                    this.hls = new Hls()
                    this.hls.loadSource(this.videoUrl)
                    this.hls.attachMedia(video)
                }

                video.volume = this.volume
                video.onvolumechange = this.onValumeChange
            })
        }
    },
    destroyed() {
        this.hls?.destroy()
    },
    methods: {
        onVideoVolumeChange() {
            this.$store.commit(
                "livestream/SET_VOLUME",
                this.$refs.videoContainer.volume
            )
            this.$store.commit(
                "livestream/SET_MUTED",
                this.$refs.videoContainer.muted
            )
        },
    },
    computed: {
        ...mapGetters("livestream", [
            "videoUrl",
            "volume",
            "thumbnailUrl",
            "muted",
            "id",
            "isLive",
            "likeCount",
        ]),
        internalShowControls() {
            return !this.noControls && this.isLive
        },
        thumbnail() {
            if (this.noThumbnail) return null
            return (
                this.thumbnailUrl ||
                require("@/assets/images/fair/stream_placeholder.jpg")
            )
        },
    },
}
